import React from 'react';
import Grid from '@material-ui/core/Grid';
import get from 'lodash/get';
import { AssuranceIcon } from 'images';
import { LongBody } from 'components/Typography';
import { HeaderWrapper } from 'containers/MyAccountPage/styles';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

type CardHeaderType = {
  title: string;
  icon: string;
};

const CardHeader = ({ title, icon }: CardHeaderType) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  return (
    <HeaderWrapper reverse={reverse}>
      <Grid container alignItems="center">
        <img
          height="24px"
          width="24px"
          src={get(AssuranceIcon, icon)}
          alt={`${icon}-icon`}
        />
        <LongBody color="#9BA4B0" weight="400">
          {title}
        </LongBody>
      </Grid>
    </HeaderWrapper>
  );
};

export default CardHeader;
